import { render, staticRenderFns } from "./AdultSingleBtnDialog.vue?vue&type=template&id=31c1884e"
import script from "./AdultSingleBtnDialog.vue?vue&type=script&lang=js"
export * from "./AdultSingleBtnDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports